import { Injectable } from '@angular/core';
import {
  Router, Resolve,
  RouterStateSnapshot,
  ActivatedRouteSnapshot
} from '@angular/router';
import { NEVER, Observable, of } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { UserAccountInfo } from 'src/app/models/user-account-info.model';
import { SiteNotesService } from 'src/app/services/sections/site-notes/site-notes.service';
import { GlobalSettingsService } from 'src/app/services/ui/global-settings.service';

@Injectable({
  providedIn: 'root'
})
export class SiteNotesAccountInfoResolver implements Resolve<UserAccountInfo> {
  constructor(
    private router: Router,
    private siteNotesService: SiteNotesService
  ) { }
  resolve(activatedRouteSnapshot: ActivatedRouteSnapshot, routerStateSnapshot: RouterStateSnapshot) {
    
    GlobalSettingsService.isSecondaryLoaderLoading = true;

    let jobId = +activatedRouteSnapshot.paramMap.get('jobId');

    return this.siteNotesService.getUserAccountInfo(activatedRouteSnapshot.paramMap.get('token'), !jobId ? null : jobId)
      .pipe(
        catchError(() => {
          this.router.navigate(['/404']);
          GlobalSettingsService.isSecondaryLoaderLoading = false;
          return NEVER;
        })
      )
  }
}
